import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ButtonGroup from 'reactstrap/lib/ButtonGroup';
import { noop } from 'lodash';
import { Tab } from './tab';

import './tabs-panel.scss';

export function TabsPanel({
  options,
  selectedOption,
  onTabClick,
  className,
  tabClassName,
  labelClassName,
  activeLabelClassName,
  iconClassName,
  ariaLabel,
}) {
  return (
    <ButtonGroup className={classnames('tabs-panel', className)} role="tablist" aria-label={ariaLabel}>
      {options.map(({ value, label, icon, link, trackingId, dataTest, disabled, ariaControls }) => {
        const isActive = selectedOption === value;
        return (
          <Tab
            key={value}
            tabId={value}
            color="link"
            isActive={isActive}
            onClick={onTabClick}
            label={label}
            icon={icon}
            className={tabClassName}
            trackingId={trackingId}
            dataTest={dataTest}
            link={link}
            labelClassName={classnames(labelClassName, { [activeLabelClassName]: isActive })}
            iconClassName={iconClassName}
            disabled={disabled}
            ariaControls={ariaControls}
          />
        );
      })}
    </ButtonGroup>
  );
}

TabsPanel.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      link: PropTypes.string,
    })
  ).isRequired,
  selectedOption: PropTypes.string.isRequired,
  onTabClick: PropTypes.func,
  className: PropTypes.string,
  tabClassName: PropTypes.string,
  activeLabelClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  ariaLabel: PropTypes.string,
};

TabsPanel.defaultProps = {
  className: '',
  tabClassName: 'pt-0 pb-0_5 px-1',
  activeLabelClassName: '',
  onTabClick: noop,
  labelClassName: '',
  iconClassName: '',
  ariaLabel: undefined,
};
